import React from 'react';
import { ActionButtonStyled } from './styles';
import { HELP_BTN_TEST_ID } from '../constants';

export const HelpButton: React.FC = () => {
  const redirectToKnowledgeCenter = (): void => {
    window.open(
      'https://insurancemenu.zendesk.com/hc/en-us/articles/19722527715604-I-m-having-trouble-uploading-an-XLSX-Census',
      '_blank',
    );
  };
  return (
    <ActionButtonStyled type="text" color="primary" onClick={redirectToKnowledgeCenter} data-test-id={HELP_BTN_TEST_ID}>
      If you are having trouble uploading a census, visit our knowledge center.
    </ActionButtonStyled>
  );
};
